export default function (mortgage, config) {
    const accountDetails = JSON.parse(mortgage.requirement.ddBankAccountDetails || '{}')
    const accountAddress = (accountDetails.address || '').split('\n')
//3072
    const accountNumber = () => {
        let map = {}
        let ask = []
        let errors = []
        ask.push({
            name: 'mortgage-account-number',
            label: 'Mortgage Account Number',
            type: 'TEXT',
            group: 'MORTGAGE'
        })
        if (config.hasOwnProperty('mortgage-account-number')) {
            map['mortgage-account-number'] = config['mortgage-account-number'].toUpperCase()
        } else if (!mortgage.activeSubmission?.mortgageAccountNo) {
            errors.push('No mortgage account number')
        } else {
            map['mortgage-account-number'] = mortgage.activeSubmission?.mortgageAccountNo.toUpperCase()
        }

        return {map, ask, errors}
    }
    const iban = () => {
        let map = {}
        let ask = []
        let errors = []

        ask.push({
            name: 'iban',
            label: 'IBAN',
            type: 'TEXT',
            group: 'MORTGAGE'
        })
        if (config.hasOwnProperty('iban')) {
            map['iban'] = config['iban'].toUpperCase()
        } else if (accountDetails.iban) {
            map['iban'] = accountDetails.iban.toUpperCase()
        } else {
            errors.push('No IBAN')
        }

        return {map, ask, errors}
    }
    const bic = () => {
        let map = {}
        let ask = []
        let errors = []
        ask.push({
            name: 'bic',
            label: 'BIC',
            type: 'TEXT',
            group: 'MORTGAGE'
        })
        if (config.hasOwnProperty('bic')) {
            map['bic'] = config['bic'].toUpperCase()
        } else if(accountDetails.bic){
            map['bic'] = accountDetails.bic.toUpperCase()
        } else {
            errors.push('No BIC')
        }

        return {map, ask, errors}
    }

    const address = () => {
        let map = {}
        let ask = []
        let errors = []
        ask.push({
            name: 'account-holder',
            label: 'Account Holder',
            type: 'TEXT',
            group: 'MORTGAGE'
        })
        ask.push({
            name: 'address-1',
            label: 'Address Line 1',
            type: 'TEXT',
            group: 'MORTGAGE'
        })
        ask.push({
            name: 'address-2',
            label: 'Address Line 2',
            type: 'TEXT',
            group: 'MORTGAGE'
        })
        ask.push({
            name: 'address-3',
            label: 'Address Line 3',
            type: 'TEXT',
            group: 'MORTGAGE'
        })
        ask.push({
            name: 'address-4',
            label: 'Address Line 4',
            type: 'TEXT',
            group: 'MORTGAGE'
        })
        ask.push({
            name: 'post-code',
            label: 'Post Code',
            type: 'TEXT',
            group: 'MORTGAGE'
        })
        ask.push({
            name: 'country',
            label: 'Country',
            type: 'TEXT',
            group: 'MORTGAGE'
        })
        if (config.hasOwnProperty('account-holder')) {
            map['account-holder'] = config['account-holder'].toUpperCase()
        } else if (accountDetails.name) {
            map['account-holder'] = accountDetails.name.toUpperCase()
        } else {
            errors.push('No account holder')
        }

        if (config.hasOwnProperty('address-1')) {
            map['holder-address-1'] = config['address-1']?.toUpperCase()
            map['holder-address-2'] = config['address-2']?.toUpperCase()
            map['holder-address-3'] = config['address-3']?.toUpperCase()
            map['holder-address-4'] = config['address-4']?.toUpperCase()
        } else if (accountAddress[0] ?? null){
            map['holder-address-1'] = (accountAddress[0] ?? '').toUpperCase()
            map['holder-address-2'] = (accountAddress[1] ?? '').toUpperCase()
            map['holder-address-3'] = (accountAddress[2] ?? '').toUpperCase()
            map['holder-address-4'] = (accountAddress[3] ?? '').toUpperCase()
        } else {
            //rpa_TG82Z8HEXRHJ2CZZY7W8RXMAVJG7JNVH5VYAV2K5vms4cr
            errors.push('No address')
        }

        if (config.hasOwnProperty('post-code')) {
            map['holder-address-post-code'] = config['post-code'].toUpperCase()
        } else if (accountDetails.postCode){
            map['holder-address-post-code'] = accountDetails.postCode.toUpperCase()
        }else {
            errors.push('No post code')
        }

        if (config.hasOwnProperty('country')) {
            map['holder-address-country'] = config['country']
        } else if (accountDetails.country){
            map['holder-address-country'] = accountDetails.country.toUpperCase()
        }else {
            map['holder-address-country'] = 'IRELAND'
        }
        return {map, ask, errors}
    }

    const sections = [
        accountNumber(),
        iban(),
        bic(),
        address(),
    ]
    sections.forEach(section=>{
        Object.keys(section.map || {}).forEach(key=>{
            if (section.map[key] === null || section.map[key] === undefined) {
                delete section.map[key]
            } else {
                section.map[key] = section.map[key].replace(/[\x00-\x1F\x7F-\x9F]/g, '');
            }
        })
    })
    return {sections}

}